import React from 'react';
import BrandCategoryLinks from './BrandCategoryLinks';

function BrandCategoryWithoutProducts({items, getMessage}) {
  if (items.length === 0) {
    return null;
  }

  return (
    <section className="mt-[40px] bg-grey-5 py-[20px]">
      <div className="max-w-[1600px] px-[20px] mx-auto grid grid-cols-1 gap-[20px] desktop:grid-cols-2 min-1024:py-[40px] phone:py-[20px]">
        {items.map(block => (
          <div
            key={`brand-content-${block.id}`}
            className="relative overflow-hidden rounded-[14px] bg-white p-[30px] flex gap-[20px] justify-between phone:flex-col phone:items-start 500:!p-[20px]"
          >
            <div className="relative z-10 max-w-[55%] phone:max-w-full">
              <div className="title-section">
                {block.hideLink ? (
                  <span className="text-[28px] text-black !font-['OtoiwoGroteskExtended'] font-semibold leading-normal phone:text-[20px] 500:!text-[18px]">
                    {block.title}
                  </span>
                ) : (
                  <a href={block.url} className="border-b border-l-0 border-t-0 border-r-0 border-solid border-transparent pb-[2px] hover:border-black">
                    <span className="text-[28px] text-black !font-['OtoiwoGroteskExtended'] font-semibold leading-normal phone:text-[20px] 500:!text-[18px]">
                      {block.title}
                    </span>
                  </a>
                )}
              </div>

              {Array.isArray(block.descriptions) && block.descriptions.length > 0 && (
                <div>
                  {block.descriptions.map((description, index) => (
                    <p
                      key={`brand-content-description-${block.id}-${index}`}
                      className="mt-[20px] mb-0"
                    >
                      {description}
                    </p>
                  ))}
                </div>
              )}

              <BrandCategoryLinks block={block} getMessage={getMessage} light/>
            </div>

            {block.image?.src && (
              <a href={block.url} className="flex h-auto w-[45%] lg:max-w-[300px] phone:m-auto 500:w-full">
                <img
                  src={block.image.src}
                  alt={block.image.alt || block.title}
                  title={block.image.title || block.title}
                  width={block.image.width || undefined}
                  height={block.image.height || undefined}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-contain"
                />
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default BrandCategoryWithoutProducts;